import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import globalAxios from "../../globalAxios";
import { SERVER_URL } from "../../config";

// Thunk: fetch search results based on query
export const searchSchedules = createAsyncThunk(
	"schedulesSearch/searchSchedules",
	async (query: string, { rejectWithValue }) => {
		try {
			const res = await globalAxios.get(
				`${SERVER_URL}/schedules/search`,
				{
					params: { query },
				}
			);
			return res.data; // Expecting array of matched schedules
		} catch (err) {
			console.error("Schedule search failed:", err);
			return rejectWithValue(err.response?.data || err.message);
		}
	}
);

interface SchedulesSearchState {
	query: string;
	results: any[];
	loading: boolean;
	error: string | null;
}

const initialState: SchedulesSearchState = {
	query: "",
	results: [],
	loading: false,
	error: null,
};

const schedulesSearchSlice = createSlice({
	name: "schedulesSearch",
	initialState,
	reducers: {
		clearSearchResults: (state) => {
			state.query = "";
			state.results = [];
			state.loading = false;
			state.error = null;
		},
		setSearchQuery: (state, action: PayloadAction<string>) => {
			state.query = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(searchSchedules.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(searchSchedules.fulfilled, (state, action) => {
				state.results = action.payload;
				state.loading = false;
			})
			.addCase(searchSchedules.rejected, (state, action) => {
				state.error = action.payload as string;
				state.loading = false;
			});
	},
});

export const { clearSearchResults, setSearchQuery } =
	schedulesSearchSlice.actions;

export const selectScheduleSearchResults = (state) =>
	state.schedulesSearch.results;

export default schedulesSearchSlice.reducer;
